import utils from "../../../utils/utils.js";
export default {
    async fetchFaqs(context,payload){        
         const response = await utils.utility.fetch(`api/Faq/GetFaqs?pageType=${payload.pageType}`, "GET", null, null);
        context.commit("setFaqs", response.data);
    }
}